import './OutlineBox.scss'
export function OutlineBox(props:{title?:string, width?:number, children:React.ReactNode}){
    const Title = (props:{title?:string}) => {
        if(props.title){
            return <div className={'outline-box-title-container'}><div className={'outline-box-title'}>{props.title}</div></div>
        }
        return null
    }
    const width:string = (props.width) ? String(props.width + 'px') : '100%'
    return(
        <div className={'outline-box'}>
            <Title title={props.title}/>
            {props.children}
        </div>
    )
}